export default {
  install(Vue, options = {}) {
    const o = Object.assign({enabled: true, debug: false}, options)
    Vue.prototype.$gtag = function (action, category, label, value) {
      if (o.enabled) {
        gtag('event', action, {event_category: category, event_label: label, value: value})
      }
      if (o.debug) {
        console.log({action, category, label, value})
      }
    }
  }
}